<template>
  <div class="cx_card_item" :class="{right: right}">
    <span :class="{cx_link_item : link || openlink || func}" @click="onClick"><slot></slot></span>    
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';

@Component
export default class GridItem extends Vue {
@Prop({default:null}) link:string;
@Prop({default:null}) openlink:string;
@Prop({default:false}) func : boolean;
@Prop({default:false}) right:boolean;


public onClick() {
  if (this.link){
    this.$router.push(this.link);     
  } else if (this.openlink){
    let routeData = this.$router.resolve(this.openlink) ;
    window.open(routeData.href, '_blank');    
  } else if (this.func){
    this.$emit('click');
  }
}
}
</script>
<style lang="scss">
.cx_card_item{
  white-space:nowrap;
  overflow-x:hidden;
  font-size: 14px;

  &.right{
    text-align: right;
  }
}
</style>
